import { render, staticRenderFns } from "./overview-main-card.component.vue?vue&type=template&id=68558e8f&scoped=true&"
import script from "./overview-main-card.component.vue?vue&type=script&lang=ts&"
export * from "./overview-main-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-main-card.component.vue?vue&type=style&index=0&id=68558e8f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68558e8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
